import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="cambio" className="bg-navy" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-17" data-mp="3iqgg60132bpm">
        <Reveal className="text-center" data-id="element-18" data-mp="3iodprew0qgkd">
          <h2 id="cambio" className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl lg:text-3xl" data-id="element-19" data-mp="3nohwweb1dyxx">
            ¿Qué puede cambiar cuando empiezas?
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-gold sm:text-[0.95rem]" data-id="element-20" data-mp="3dsonh3sm6lkd">
            Aprender las bases del inglés puede abrir nuevas posibilidades.
          </p>
        </Reveal>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="34r8aqpebu7cz">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-royal bg-navy-deep p-3" data-id="element-22" data-mp="y0qzrikqehut" data-mpi={i}>
              <span aria-hidden="true" className="text-xl" data-id="element-23" data-mp="2bd30zuvz56rr">
                {benefit.icon}
              </span>
              <h3 className="mt-1 font-sans text-[0.78rem] font-extrabold uppercase leading-tight text-gold sm:text-[0.85rem]" data-id="element-24" data-mp="2l4z8txnv4b96">
                {benefit.title}
              </h3>
              <p className="mt-1 text-[0.73rem] leading-snug text-ivory sm:text-[0.8rem]" data-id="element-25" data-mp="2g7z35nuxdail">
                {benefit.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}